import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList, ChangeDetectionStrategy} from '@angular/core';
import {TabItemComponent} from "./tab-item/tab-item.component";

@Component({
    selector: 'app-tab-panel',
    templateUrl: './tab-panel.component.html',
    styleUrls: ['./tab-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabPanelComponent implements AfterContentInit {
  @ContentChildren(TabItemComponent) tabs!: QueryList<TabItemComponent>;
  activeTab!: TabItemComponent;
  @Input() activeIndex: number = 0;
  @Input() sticky: boolean;
  @Input() alwaysRender: boolean;
  @Output() tabChange: EventEmitter<TabInfo> = new EventEmitter<TabInfo>();

  ngAfterContentInit() {
    this.activateTab(this.tabs.toArray()[this.activeIndex], this.activeIndex);
    this.tabs.changes.subscribe(() => this.activateTab(
      this.activeTab, this.activeIndex));
  }

  activateTab(tab: TabItemComponent, index: number) {
    this.activeTab = tab;
    this.tabChange.emit({
      index: index,
      tab: tab
    });
  }
}

export interface TabInfo {
  index: number;
  tab: TabItemComponent;
}
